export default __webpack_public_path__ + "static/media/layout1.0ade9e19.svg";